import React, { Component, Suspense } from 'react'
import { Router, Route, Switch } from "react-router-dom";
import * as firebase from "firebase/app";
import "firebase/auth";
import './App.css'

// import NetlifyRepoList from './pages/netlify/repo-list';
import history from './history';
import Dashboard from './pages/dashboard';
import Signup from './pages/auth/signup';
import Login from './pages/auth/login';

import Loading from './components/Loading';
import PrivateRoute from './utils/PrivateRoute';
import ProjectList from './pages/dashboard/ProjectList';

const firebaseConfig = {
  apiKey: "AIzaSyDdt2Yr_jkUTTD6e_q82n6Zip7IBKtuGXE",
  authDomain: "portfoliox-gen.firebaseapp.com",
  databaseURL: "https://portfoliox-gen.firebaseio.com",
  projectId: "portfoliox-gen",
  storageBucket: "",
  messagingSenderId: "577569828299",
  appId: "1:577569828299:web:28a72d1669210bfb"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);


const RouteWithSubRoutes = route => {
  if (route.private) {
    return (
      <PrivateRoute exact path={route.path} component={route.component} />
    );
  }
  return (
    <Route
      path={route.path}
      render={props => (
        // Pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
};


function withDashboard(WrappedComponent) {
  return class DashboardWrapped extends Component {
    // state = {
    //   collapsed:
    //     JSON.parse(localStorage.getItem('Side')) || window.innerWidth <= SIDEBAR_WRAP_WIDTH,
    // };

    // toggle = () => {
    //   localStorage.setItem('Side', (!this.state.collapsed).toString());
    //   this.setState({
    //     collapsed: !this.state.collapsed,
    //   });
    // };
    render() {
      return (
        <Dashboard
          {...this.props}
          // collapsed={this.state.collapsed}
          // toggle={this.toggle}
        >
          <WrappedComponent {...this.props} />
        </Dashboard>
      );
    }
  };
}


export default class App extends Component {
  constructor(props, context) {
    super(props, context)

    /* Set initial app state */
    this.state = {
      user: {},
    }
    this.uiConfig = {
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      callbacks: {
        signInSuccessWithAuthResult: () => false,
      },
    };
  }
  async componentDidMount() {
    // const user = await firebase.auth()
    // console.log('user get')
    // this.setState({
    //   user: {
    //     displayName: user.displayName,
    //     email: user.email,
    //     emailVerified: user.emailVerified,
    //     photoURL: user.photoURL,
    //     uid: user.uid,
    //     providerData: user.providerData
    //   }
    // })
  }

  render() {

    const routes = [
      {
        path: "/login",
        component: Login,
      },
      {
        path: "/signup",
        component: Signup,
      },
      {
        path: "/dashboard",
        component: withDashboard(ProjectList),
        private: true,
      },
    ];

    /* Show admin UI */
    return (
      <div>
        <Suspense fallback={<Loading />}>
          <Router history={history}>
            <Switch>
              {routes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              <RouteWithSubRoutes path="/" component={Login} />
            </Switch>
          </Router>
        </Suspense>
      </div>
    )
  }
}
